/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  Comment: [],
  UserIdForComment: '',
}

export const PortalNotifiationBySuperAdmin: any = createAsyncThunk(
  '/PortalNotifiationBySuperAdmin',
  async (data) => {
    const response: any = await axios.post(`${API_URL}notification/createNotification`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }

    return response.data
  }
)

export const GetAllComment: any = createAsyncThunk(
  '/GetAllComment',
  async (data, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/getComment`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const PostComment: any = createAsyncThunk(
  '/PostComment',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/createComment`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(
      GetAllComment({
        userId: data?.userId,
      })
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
const Comment = createSlice({
  name: 'comment',
  initialState,
  reducers: {
    UserIdForComment: (state, {payload}) => {
      return {...state, UserIdForComment: payload.id}
    },
  },
  extraReducers: {
    [GetAllComment.fulfilled]: (state, {payload}) => {
      return {...state, Comment: payload}
    },
  },
})

export const {UserIdForComment} = Comment.actions
export default Comment.reducer
